'use strict';

module.exports = require('./is-implemented')()
	? Object.keys
	: require('./shim');



/*****************
 ** WEBPACK FOOTER
 ** /Users/dan/p/react-devtools/~/es5-ext/object/keys/index.js
 ** module id = 194
 ** module chunks = 0
 **/